import { render, staticRenderFns } from "./production_report.vue?vue&type=template&id=023fa27f&scoped=true&"
import script from "./production_report.vue?vue&type=script&lang=js&"
export * from "./production_report.vue?vue&type=script&lang=js&"
import style0 from "./production_report.vue?vue&type=style&index=0&id=023fa27f&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023fa27f",
  null
  
)

export default component.exports